import { render, staticRenderFns } from "./ReorderCollectionModal.vue?vue&type=template&id=6a154668&lang=pug&"
import script from "./ReorderCollectionModal.vue?vue&type=script&lang=js&"
export * from "./ReorderCollectionModal.vue?vue&type=script&lang=js&"
import style0 from "./ReorderCollectionModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports